import * as types from '../actions/ActionTypes';

const INITIAL_STATE = {
  data: [],
  tempData: [],
  selectedData: [],
  editEnabled: false,
  isLoading: false,
  isError: false
};

export function usersReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.GET_TEAM_PENDING: {
      return {
        ...state,
        isLoading: true,
        isError: null
      };
    }
    case types.GET_TEAM_SUCCESS:
      return {
        data: action.payload,
        isLoading: false,
        isError: null
      };
    case types.GET_TEAM_REJECTED:
      return {
        ...state,
        isError: true,
        isLoading: false
      };

    case types.CREATE_USER_PENDING: {
      return {
        ...state,
        isLoading: true,
        isError: null
      };
    }
    case types.CREATE_USER_SUCCESS:
      return {
        ...state,
        isError: null
      };
    case types.CREATE_USER_REJECTED:
      return {
        ...state,
        isError: true,
        isLoading: false
      };

    case types.UPDATE_USER_PENDING: {
      return {
        ...state,
        isLoading: true,
        isError: null
      };
    }
    case types.UPDATE_USER_SUCCESS:
      return {
        ...state,
        isError: null
      };
    case types.UPDATE_USER_REJECTED:
      return {
        ...state,
        isError: true,
        isLoading: false
      };

    case types.DELETE_USER_PENDING: {
      return {
        ...state,
        isLoading: true,
        isError: null
      };
    }
    case types.DELETE_USER_SUCCESS:
      return {
        ...state,
        isError: null
      };
    case types.DELETE_USER_REJECTED:
      return {
        ...state,
        isError: true,
        isLoading: false
      };
    case types.REGISTRATION_EMAIL_PENDING:
      return {
        ...state,
        isLoading: true
      };
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/users.reducer.js